import { FILES_PER_PAGE } from './folders.constants';
import { FileResource, FolderResource } from './folders.types';

export function buildCreateFileFormData(fileResource: FileResource, document: File): FormData {
  const formData = new FormData();
  Object.entries(fileResource || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(`file_resource[${key}]`, value as string);
    }
  });
  formData.append('document[attachment]', document);
  return formData;
}

export function hasMoreFiles(folder: FolderResource | null | undefined): boolean {
  const pagination = folder?.file_resources_pagination;
  return !!pagination && (pagination.page ?? 1) * FILES_PER_PAGE < pagination.count;
}

export function mergeFilePage(current: FolderResource, next: FolderResource): FolderResource {
  const loadedIds = new Set(current.file_resources.map(({ id }) => id));

  return {
    ...current,
    file_resources: [...current.file_resources, ...next.file_resources.filter(({ id }) => !loadedIds.has(id))],
    file_resources_pagination: next.file_resources_pagination,
  };
}
